import { render, staticRenderFns } from "./putStorage.vue?vue&type=template&id=783ec2f5&"
import script from "./putStorage.vue?vue&type=script&lang=js&"
export * from "./putStorage.vue?vue&type=script&lang=js&"
import style0 from "./putStorage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports